// Config.
import Config 	from './config/config.js';

// Misc dependencies.
import createActionTypes from '../../../factories/actionTypes.js';

/**
 * <pre>
 * Voting module Action Types.
 *
 * Summary of responsibilities:
 *
 *  - defines Redux action types specific to component
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Voting
 * @namespace
 *
 * @type {Object}
 * @property {String} VOTING Dispatched whilst voting is taking place.
 * @property {String} VOTE_SUCCESS Dispatched after voting has been successful.
 * @property {String} VOTE_FAILURE Dispatched if voting encounters an error.
 * @property {String} SHOW_DYN_RECAPTCHA Dispatched during voting if the server requires us to complete a Captcha.
 * @property {String} HIDE_DYN_RECAPTCHA Dispatched when we need to hide the Captcha.
 * @property {String} SHOW_POST_VOTE_CTA Dispatched if the module has a Call To Action overlay defined after voting.
 * @property {String} HIDE_POST_VOTE_CTA Dispatched when we need to hide the CTA overlay.
 * @property {String} SHOW_MESSAGE Dispatched if an error occurs and we need to show a message.
 * @property {String} SHOW_MESSAGE Dispatched when we need to hide the message.
 */
const ActionTypes = {

	VOTING: 				'VOTING',
	VOTE_SUCCESS: 			'VOTE_SUCCESS',
	VOTE_FAILURE: 			'VOTE_FAILURE',

	SHOW_DYN_RECAPTCHA: 	'SHOW_DYN_RECAPTCHA',
	HIDE_DYN_RECAPTCHA: 	'HIDE_DYN_RECAPTCHA',

	SHOW_POST_VOTE_CTA: 	'SHOW_POST_VOTE_CTA',
	HIDE_POST_VOTE_CTA: 	'HIDE_POST_VOTE_CTA',

	SHOW_MESSAGE: 			'SHOW_MESSAGE',
	HIDE_MESSAGE: 			'HIDE_MESSAGE'
};

export default createActionTypes(ActionTypes, Config.stateKey);